import { LayoutComponent } from '../layout/layout.component';

import { LoginComponent } from './pages/login/login.component';
import { RecuperarSenhaComponent } from './pages/recuperar-senha/recuperar-senha.component';
import { IconsComponent } from './pages/icons/icons.component';
import { AcessoComponent } from './pages/acesso/acesso.component';
import { Routes } from "@angular/router";

import { GuardGuard } from '../guards/guard.guard';
import { environment } from '../../environments/environment';

export const routes: Routes = [

    ...(environment.gameCardioEnabled ? [
        { path: 'game-cardio', loadComponent: () => import('./game-cardio/game-cardio.component').then(m => m.GameCardioComponent) },
    ] : []),

    { path: '', component: LoginComponent, pathMatch: 'full' },

    {
        path: '',
        component: LayoutComponent,
        canActivateChild: [GuardGuard],
        children: [
            { path: 'projetos', loadComponent: () => import('../platform/projects.component').then(m=>m.ProjectsComponent) },
            { path: 'administracao', loadComponent: () => import('../platform/admin.component').then(m=>m.AdminComponent) },
            { path: 'lotes-mensagens', loadChildren: () => import('./lotesMensagens/lotesMensagens.module').then(m => m.LotesMensagensModule) },
            { path: 'comunicacoes', loadChildren: () => import('./comunicacoes/comunicacoes.module').then(m => m.ComunicacoesModule) },
            { path: 'waf-access-blocks', loadChildren: () => import('./wafAccessBlocks/waf-access-blocks.module').then(m => m.WafAccessBlocksModule) },
            { path: 'sogesp', loadChildren: () => import('./sogesp/sogesp.module').then(m => m.SogespModule) },
            { path: 'game-cardio-admin', loadComponent: () => import('./game-cardio/game-cardio-admin.component').then(m => m.GameCardioAdminComponent) },
        ]
    },
    
    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },
    { path: 'recuperar-senha', component: RecuperarSenhaComponent },
    { path: 'icones', component: IconsComponent },
    { path: 'acesso-negado', component: AcessoComponent },

    // Not found
    { path: '**', redirectTo: 'login' }
];
